module.exports = window["bonnet-webcomponent-react-redux"];